// Author Liang Gang Qiang
// Date 2021-11-18 16:39:59

class ImfMstCalendar {
constructor({
        id = null,
        calendarType = '',
        beginTime = '',
        endTime = '',
        mstLocationId = '',
        mstLocationName = '',
        ratedWorkingHours = '',
        headCount = '',
        remark = ''}
= {}) {
    this.id = id;
    this.calendarType = calendarType;
    this.beginTime = beginTime;
    this.endTime = endTime;
    this.mstLocationId = mstLocationId;
    this.mstLocationName = mstLocationName;
    this.ratedWorkingHours = ratedWorkingHours;
    this.headCount = headCount;
    this.remark = remark;
}
}

function newEntity() {
return new ImfMstCalendar();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'calendarType',
        label: 'label.em.admin.imfMstCalendar.grid.calendarType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                // { value: '1', text: '法定节假日' },
                //             { value: '2', text: '法定串休工作日' },
                //             { value: '3', text: '加班' },
                //             { value: '4', text: '调休' },
                //             { value: '5', text: '设备检修' },
                            { value: '6', text: '停机计划' }
            ]
        }
        },
        {
        key: 'beginTime',
        label: 'label.em.admin.imfMstCalendar.grid.beginTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'endTime',
        label: 'label.em.admin.imfMstCalendar.grid.endTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstLocationName',
        label: 'label.em.admin.imfMstCalendar.grid.mstLocationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstLocationNodeCode',
        label: 'label.em.admin.imfMstCalendar.grid.mstLocationNodeCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.imfMstCalendar.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    calendarTypeFilter : '',
    beginTimeRteFilter : '',
    beginTimeLteFilter : '',
    endTimeRteFilter : '',
    endTimeLteFilter : '',
    mstLocationIdFilter : '',
    mstLocationNameFilter : '',
    startsWithMstLocationNodeCodeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'calendarTypeFilter',
        label: 'label.em.admin.imfMstCalendar.filter.calendarType',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                // { value: '1', text: '法定节假日' },
                // { value: '2', text: '法定串休工作日' },
                // { value: '3', text: '加班' },
                // { value: '4', text: '调休' },
                // { value: '5', text: '设备检修' },
                { value: '6', text: '停机计划' }
            ]
        }
        },
        {
        key: 'beginTimeRteFilter',
        label: 'label.em.admin.imfMstCalendar.filter.beginTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'beginTimeLteFilter',
        label: 'label.em.admin.imfMstCalendar.filter.beginTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'endTimeRteFilter',
        label: 'label.em.admin.imfMstCalendar.filter.endTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'endTimeLteFilter',
        label: 'label.em.admin.imfMstCalendar.filter.endTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'mstLocationNameFilter',
        label: 'label.em.admin.imfMstCalendar.filter.mstLocationName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstLocationId":"id"}'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'calendarType',
        label: 'label.em.admin.imfMstCalendar.entity.calendarType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                // { value: '1', text: '法定节假日' },
                // { value: '2', text: '法定串休工作日' },
                // { value: '3', text: '加班' },
                // { value: '4', text: '调休' },
                // { value: '5', text: '设备检修' },
                { value: '6', text: '停机计划' }
            ]
        }
        },
        {
        key: 'beginTime',
        label: 'label.em.admin.imfMstCalendar.entity.beginTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'endTime',
        label: 'label.em.admin.imfMstCalendar.entity.endTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'mstLocationName',
        label: 'label.em.admin.imfMstCalendar.entity.mstLocationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstLocationId":"id"}'
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.imfMstCalendar.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {ImfMstCalendar, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
